<template>
<div>
<Navbar />


<!-- Hero Start -->
    <section class="d-table w-100">
      <div class="main_top_login_page_bg_hero">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-12 text-center">
              <div class="page-next-level">
                <h4 class="login-page-top-im-title"> my<span style="color: #2eca8b">Account</span> </h4>
                <p class="login-page-top-im-ptext">Login to myUni dashboard</p>
                <div class="r_login_p_log_sign_b_div r-c-d-flex">
                  <button 
                    class="btn btn-outline-light r_login_signup_p_log_b_"
                    :class="signInFormClass"
                    id="kt_login_signup_cancel"
                    @click="showForm('signin')"
                    >
                    Login
                  </button>
                  <button
                    id="kt_login_signup"
                    class="btn btn-outline-light r_login_signup_p_log_b_"
                    :class="signUpFormClass"
                    @click="showForm('signup')"
                    >Register</button
                  >
                  <button class=""></button>
                </div>
                <div class="page-next"></div>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
    </div>
    <!-- Hero End -->



  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluids"
      :class="{
        'login-signin-on': this.state == 'signin',
        'login-signup-on': this.state == 'signup',
        'login-forgot-on': this.state == 'forgot',
      }"
      id="kt_login"
    >
      <!--begin::Aside-->
      <!-- <div
        class="login-aside d-flex flex-column flex-row-auto"
        style="background-color: #f2c98a"
      >
        <div class="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
          <a href="#" class="text-center mb-10">
            <img src="media/logos/logo-letter-1.png" class="max-h-70px" alt="" />
          </a>
          <h3
            class= text-center font-size-h4 font-size-h1-lg"
            style="color: #986923"
          >
            Login to MYUNI Dashboard
          </h3>
        </div>
        <div
          class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
          :style="{ backgroundImage: `url(${backgroundImage})` }"
        ></div>
      </div> -->
      <!--begin::Aside-->
      <!--begin::Content-->
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto "
      >
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin">
            <form
              class="form r_login_p_form_p"
              novalidate="novalidate"
              id="kt_login_signin_form"
              @submit.stop.prevent="onSubmitLogin()"
            >
              <!-- <div class="pb-13 pt-lg-0 pt-5">
                <h3 class= text-dark font-size-h4 font-size-h1-lg">
                  Welcome to MyUni
                </h3>
                <span class="text-muted font-weight-bold font-size-h4"
                  >New Here?
                  <a
                    id="kt_login_signup"
                    class="text-primary"
                    @click="showForm('signup')"
                    >Create an Account</a
                  ></span
                >
              </div> -->
              <div class="form-group">
                <label class="font-size-h6 text-dark r_login_p_lbl">Your email address <span class="text-danger">*</span></label>
                <div id="example-input-group-1" label="" label-for="example-input-1">
                  <input
                    class="form-control form-control-solid h-auto py-7 px-6 rounded-lg r_login_p_inp"
                    type="text"
                    name="email"
                    ref="email"
                    v-model="form.email"
                  />
                </div>
              </div>

              <div class="form-group">
                <div class="d-flex justify-content-between mt-n5">
                  <label class="font-size-h6 text-dark pt-5 r_login_p_lbl"
                    >Password <span class="text-danger">*</span></label
                  >
                  <a
                    class="text-primary font-size-h6 text-hover-primary pt-5 r_lgn_p_db_clr"
                    id="kt_login_forgot"
                    role="button"
                    @click="showForm('forgot')"
                    >Forgot Password?</a
                  >
                </div>
                <div id="example-input-group-2" label="" label-for="example-input-2">
                  <input
                    class="form-control form-control-solid h-auto py-7 px-6 rounded-lg r_login_p_inp"
                    type="password"
                    name="password"
                    ref="password"
                    v-model="form.password"
                    autocomplete="off"
                  />
                </div>
              </div>
              <span class="text-danger" v-if="loginError && loginError.length"> {{loginError}} </span>
              <div class="pb-lg-0 pb-5 text-center">
                <button
                  ref="kt_login_signin_submit"
                  class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 r_lgn_p_signin_btn"
                >
                  Login
                </button>
                <button
                  type="button"
                  class="btn btn-light-primary px-8 py-4 my-3 font-size-lg r_lgn_p_signin_ggl_btn"
                >
                  <span class="svg-icon svg-icon-md">
                    <inline-svg src="media/svg/social-icons/google.svg" /> </span
                  >Sign in with Google
                </button>
              </div>
            </form>
          </div>
          <!--end::Signin-->
          <!--begin::Signup-->
          <div class="login-form login-signup">
            <form
              class="form r_login_p_form_p"
              novalidate="novalidate"
              id="kt_login_signup_form"
              @submit.stop.prevent="onSubmitRegister()"
            >
              <!-- <div class="pb-13 pt-lg-0 pt-5">
                <h3 class= text-dark font-size-h4 font-size-h1-lg">
                  Sign Up
                </h3>
                <p class="text-muted font-weight-bold font-size-h4">
                  Enter your details to create your account
                </p>
              </div> -->
              <div class="form-group r_login_p_reg_form_radio_div">
                <input
                  type="radio"
                  v-model="user_role"
                  name="role"
                  ref="role"
                  value="3"
                  class="r_login_p_reg_form_radio"
                /> Student 
                <input
                  type="radio"
                  v-model="user_role"
                  name="role"
                  ref="role"
                  value="1"
                  class="r_login_p_reg_form_radio r_lprfr_ml"
                /> Institute
              </div>
              <div class="form-group">
                <label class="font-size-h6 text-dark r_login_p_lbl">Full name <span class="text-danger">*</span></label>
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg r_login_p_inp"
                  type="text"
                  placeholder="Fullname"
                  name="fullname"
                  ref="fullname"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <label class="font-size-h6 text-dark r_login_p_lbl">Your email address <span class="text-danger">*</span></label>
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg r_login_p_inp"
                  type="email"
                  placeholder="Email"
                  name="email"
                  ref="remail"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <label class="font-size-h6 text-dark r_login_p_lbl">Password <span class="text-danger">*</span></label>
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg r_login_p_inp"
                  type="password"
                  placeholder="Password"
                  name="password"
                  ref="rpassword"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <label class="font-size-h6 text-dark r_login_p_lbl">Confirm Password <span class="text-danger">*</span></label>
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg r_login_p_inp"
                  type="password"
                  placeholder="Confirm password"
                  name="cpassword"
                  ref="cpassword"
                  autocomplete="off"
                />
              </div>
              <div class="form-group">
                <label class="checkbox mb-0 r_lgn_p_signin_checkbox">
                  <input type="checkbox" name="agree" />
                  <span class="mr-2"></span>
                  I Agree the
                  <a href="#" class="ml-2">terms and conditions</a>.
                </label>
              </div>

              <span class="text-danger" v-if="loginError && loginError.length"> {{ loginError}}</span>
              <div class="form-group d-flex flex-wrap pb-lg-0 pb-3 text-center">
                <button
                  ref="kt_login_signup_submit"
                  class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 r_lgn_p_signin_btn"
                  style="width: 150px"
                >
                  Submit
                </button>
                <button
                  type="button"
                  id="kt_login_signup_cancel"
                  class="btn btn-light-primary px-8 py-4 my-3 font-size-lg r_lgn_p_signin_ggl_btn"
                  @click="showForm('signin')"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
          <!--end::Signup-->
          <!--begin::Forgot-->
          <div class="login-form login-forgot">
            <!--begin::Form-->
            <form
              class="form r_login_p_form_p fv-plugins-bootstrap fv-plugins-framework"
              novalidate="novalidate"
              id="kt_login_forgot_form"
              ref="kt_login_forgot_form"
              @submit.stop.prevent="onSubmitForgotPassword()"
            >
              <div class="pt-lg-0">
                <!-- <h3 class= text-dark font-size-h4 font-size-h1-lg">
                  Forgotten Password?
                </h3> -->
                <p class="font-size-h6 text-dark r_login_p_lbl">
                  Enter your email to reset your password <span class="text-danger">*</span>
                </p>
              </div>
              <div class="form-group">
                <input
                  class="form-control form-control-solid h-auto py-7 px-6 rounded-lg r_login_p_inp"
                  type="email"
                  placeholder="Email"
                  name="email"
                  autocomplete="off"
                  ref="frEmail"
                />
              </div>
              <div class="form-group d-flex flex-wrap pb-lg-0">
                <button
                  ref="kt_login_forgot_submit"
                  class="btn btn-primary font-size-h6 px-15 py-4 my-3 mr-3 r_lgn_p_signin_btn"
                >
                  Get email link
                </button>
                <button
                  type="button"
                  id="kt_login_forgot_cancel"
                  class="btn btn-light-primary px-8 py-4 my-3 font-size-lg r_lgn_p_signin_ggl_btn"
                  @click="showForm('signin')"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
          <!--end::Forgot-->
        </div>
        <!--begin::Content footer-->
        <div
          class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0 r_lgn_p_trms_div"
        >
          <a href="/terms-and-conditions" class="text-primary font-size-h5 r_lgn_p_trms_a">Terms</a>
          <a href="/university/plans" class="text-primary ml-10 font-size-h5 r_lgn_p_trms_a r_lgn_p_plns">Plans</a>
          <a href="/contact" class="text-primary ml-10 font-size-h5 r_lgn_p_trms_a"
            >Contact Us</a
          >
        </div>
        <!--end::Content footer-->
      </div>
      <!--end::Content-->

      
    </div>
  </div>
  <Footer />
</div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";

import Navbar from "@/view/front/components/navbar";
import Footer from "@/view/front/components/footer";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState } from "vuex";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import IndexService from "@/MainServices/IndexService.js";
import Swal from "sweetalert2";

export default {
  name: "login-1",
  data() {
    return {
      state: "signin",
      fv1: '',
      // Remove this dummy login info
      form: {
        email: "",
        password: "",
      },
      user_role: null,
      signInFormClass: 'active',
      signUpFormClass: '',
    };
  },
  components: {
    Navbar,
    Footer
  },
  computed: {
    loginError() {
      return this.$store.state.auth.errors;
    },
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser"]),

    backgroundImage() {
      return process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg";
    },
  },
  mounted() {
    const signin_form = KTUtil.getById("kt_login_signin_form");
    const signup_form = KTUtil.getById("kt_login_signup_form");
    const forgot_form = KTUtil.getById("kt_login_forgot_form");

    this.fv = formValidation(signin_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Username is required",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv1 = formValidation(signup_form, {
      fields: {
        fullname: {
          validators: {
            notEmpty: {
              message: "Full name is required",
            },
          },
        },
        email: {
          validators: {
            notEmpty: {
              message: "Email is required",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "Password is required",
            },
          },
        },
        role: {
          validators: {
            notEmpty: {
              message: "Role is required",
            },
          },
        },
        cpassword: {
          validators: {
            notEmpty: {
              message: "Confirm password is required",
            },
            identical: {
              compare: function () {
                return signup_form.querySelector('[name="password"]').value;
              },
              message: "The password and its confirm are not the same",
            },
          },
        },
        agree: {
          validators: {
            notEmpty: {
              message: "You should agree terms and conditions",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv2 = formValidation(forgot_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Email is required",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    if (this.currentUser && this.currentUser.role == "admin") {
      this.$router.push({ name: "dashboard" });
    }
    if (this.currentUser && this.currentUser.role == "institute") {
      this.$router.push({ name: "institute-dashboard" });
    }
    if (this.currentUser && this.currentUser.role == "student") {
      this.$router.push({ name: "student-dashboard" });
    }
  },
  methods: {
    showForm(form) {
      this.loginError = "";
      this.state = form;

      if(form == 'signin'){
        this.signInFormClass = 'active';
        this.signUpFormClass = '';
      }
      else if(form == 'signup') {
        this.signInFormClass = '';
        this.signUpFormClass = 'active';
      }
      
      // var form_name = "kt_login_" + form + "_form";
      // KTUtil.animateClass(
      //   KTUtil.getById(form_name),
      //   "animate__animated animate__backInUp"
      // );
    },

    onSubmitForgotPassword() {

      let send = 'yes';

      if(this.$store.state.auth.errors)
      {
        send = 'no';
      }

      this.fv2.on("core.form.invalid", () => {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      });


      this.fv2.on("core.form.valid", () => {
        const email = this.$refs.frEmail.value;
        // clear existing errors
        // this.$store.dispatch(LOGOUT);
        // set spinner to submit button
        const submitButton = this.$refs["kt_login_forgot_submit"];
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        if(send == 'yes') {

          IndexService.forgotPassword(email).then((res)=> {
            send = 'no';
            Swal.fire({
              title: "",
              text: "Please, check your inbox or spam to verify email",
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          }).catch((error) => {
            send = 'no';
            Swal.fire({
              title: "",
              text: "Something went wrong! Please try again later",
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          });
        }
      });
    },

    async onSubmitLogin() {
  const status = await this.fv.validate();

  if (status === 'Valid') {
    const submitButton = this.$refs.kt_login_signin_submit;
    submitButton.classList.add("spinner", "spinner-light", "spinner-right");

    try {
      const { email, password } = this.form;
      const res = await this.$store.dispatch(LOGIN, { email, password });

      localStorage.setItem("user", JSON.stringify(res));
      localStorage.setItem("token", res.token);

      // redirect by role
      if (res.role === "admin") {
        this.$router.push({ name: "dashboard" });
      } else if (res.role === "institute") {
        this.$router.push({ name: "institute-dashboard" });
      } else if (res.role === "student") {
        this.$router.push({ name: "student-dashboard" });
      }
    } catch (err) {
      Swal.fire({
        text: "Invalid login. Please try again",
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false,
      });
    } finally {
      submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
    }
  } else {
    Swal.fire({
      text: "Please provide correct data!",
      icon: "error",
      confirmButtonClass: "btn btn-secondary",
      heightAuto: false,
    });
  }
},


    onSubmitRegister() {

      this.fv1.on("core.form.invalid", () => {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      });


      let send = 'yes';

      if(this.$store.state.auth.errors)
      {
        send = 'no';
      }

      this.fv1.on("core.form.valid", () => {
        const email = this.$refs.remail.value;
        const password = this.$refs.rpassword.value;
        const role_id = this.user_role;
        const name = this.$refs.fullname.value;
        const route = window.location.href;
        // clear existing errors
        this.$store.dispatch(LOGOUT);
        // set spinner to submit button
        const submitButton = this.$refs["kt_login_signup_submit"];
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        if(send == 'yes') {
          this.$store
          .dispatch(REGISTER, {
            email: email,
            password: password,
            role_id: role_id,
            name: name,
            route: route
          })
          .then((res) => {
            
            submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
            Swal.fire({
              title: "",
              text: "Thanks for Registration..! Please check your email inbox or spam folder to verify your account.",
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
            window.reload;
            send = 'no';
          });

        }
      });

      
    },
  },
};
</script>

<style scoped>
.fv-plugins-message-container {
  margin-left: 10px !important;
}
</style>
